var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#020203",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.372 8.507c-.017-2.013 1.657-3.01 1.725-3.044-.947-1.387-2.419-1.573-2.926-1.59-1.235-.135-2.436.744-3.061.744-.643 0-1.607-.727-2.656-.71-1.336.017-2.604.795-3.28 1.995-1.421 2.453-.356 6.072.997 8.068.677.98 1.472 2.063 2.52 2.03 1.015-.035 1.404-.643 2.622-.643 1.217 0 1.572.642 2.638.625 1.1-.017 1.776-.98 2.435-1.962.795-1.116 1.1-2.215 1.117-2.266-.017-.017-2.114-.829-2.131-3.247zM9.359 2.57c.541-.693.93-1.623.812-2.57-.795.034-1.793.541-2.351 1.218-.507.592-.964 1.556-.846 2.469.897.068 1.81-.44 2.385-1.116z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.016e8bfec5506ab9a3c2557098839e78.svg";
export { ForwardRef as ReactComponent };